import React, { useEffect } from "react";

interface IToastProps {
    closeToast: boolean,
    updateShowToast: (arg: boolean) => void;
}

const Toast: React.FC<IToastProps> = ({ closeToast, updateShowToast }) => {
  useEffect(() => {
    updateShowToast(closeToast);
  }, [closeToast]);

  if(!closeToast) {
      return <></>;
  } else {
    return (
        <div className="mfrm-social__toast-style">
            <p>Copied to clipboard</p>
            <button className="mfrm-social__toast-close-button" onClick={() => updateShowToast(false)}></button>
        </div>
    );
  }
};

export default Toast;